/**
 * SoleadLab 2.0 - Thermal Controls
 *
 * Toolbar with mode toggles, action buttons, and status display
 * for the thermal annotator.
 *
 * REFERENCE: editor (23).html setupThermalAnnotUi (lines 7655-7680)
 */

import type { AnnotatorMode } from './thermalTypes';
import './ThermalControls.css';

interface ThermalControlsProps {
  mode: AnnotatorMode;
  onModeChange: (mode: AnnotatorMode) => void;
  onUndoRoi: () => void;
  onClearRois: () => void;
  onClearPoints: () => void;
  isAnalyzing: boolean;
  isAnalyzed: boolean;
  statusMessage: string;
}

export default function ThermalControls({
  mode,
  onModeChange,
  onUndoRoi,
  onClearRois,
  onClearPoints,
  isAnalyzing,
  isAnalyzed,
  statusMessage,
}: ThermalControlsProps) {
  return (
    <div className="thermal-controls">
      {/* Status line */}
      {statusMessage && (
        <div className="thermal-controls__status">{statusMessage}</div>
      )}

      {/* Mode toggles + actions (only enabled after analysis) */}
      {isAnalyzed && !isAnalyzing && (
        <div className="thermal-controls__row">
          <button
            type="button"
            className={`thermal-controls__mode-btn${mode === 'rect' ? ' thermal-controls__mode-btn--active' : ''}`}
            onClick={() => onModeChange('rect')}
          >
            Rect ROI
          </button>
          <button
            type="button"
            className={`thermal-controls__mode-btn${mode === 'point' ? ' thermal-controls__mode-btn--active' : ''}`}
            onClick={() => onModeChange('point')}
          >
            Point ROI
          </button>

          <span className="thermal-controls__separator" />

          <button
            type="button"
            className="thermal-controls__action-btn"
            onClick={onUndoRoi}
            title="Remove last ROI"
          >
            Undo
          </button>
          <button
            type="button"
            className="thermal-controls__action-btn"
            onClick={onClearRois}
            title="Remove all ROIs"
          >
            Clear ROIs
          </button>
          <button
            type="button"
            className="thermal-controls__action-btn"
            onClick={onClearPoints}
            title="Remove all points"
          >
            Clear Pts
          </button>
        </div>
      )}
    </div>
  );
}
